export default __webpack_public_path__ + "static/media/conduiit-icon.06884422.svg";